
import React from 'react'

export const Listadopatrocinadores = (props) => {
   
    return  (
        <div className={`listadoPatrocinadores`} key={Math.random() * 57005}>
            {
                props.items.map((item, index) =>
                    <div className={`gruposponsor item-${props.indexitem}`} key={Math.random() * 57005}>
                        {item.titulo !== null && <div className="titulospaonsor">{item.titulo}</div>}
                        <div className="itemsponsor">
                            {item.enlace !== null ? 
                                <a href={item.enlace} target={item.targer !== null ? item.target: ''}><img src={item.imagen} /></a>
                            :
                                <img src={item.imagen} />
                            }
                            
                        </div>
                    </div> 
                )
            }
        </div>
    )
    
}
